import React, { useState, useRef } from 'react';
import { useData } from "../../../context/DataContext";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box, Paper,
    Grid,
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import CustomButton from '../../../components/buttons/customButton';
import PrintIcon from '@mui/icons-material/Print';
import { getClientTheme } from '../../../theme/clientTheme';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const PrintCell = ({ value }) => (
    <Typography variant="body2" align="center">
        {value || "-"}
    </Typography>
);

const SoilVillageDetailsModal = ({ show, handleClose, rowData }) => {
    const printRef = useRef(null);
    const filterData = rowData.yearBasedSoilData.filter((item) => item.report_level_id === 1 && item.ff_group_id === null && item.farmer_id === null)
    const filterMultipleVilagesData = filterData.filter((a) => a.village_id === rowData.villageDetailsRowData.village_id)
    const { years = [], cropTypes = [], soilTypes = [], user_client_id } = useData();
    const yearIndex = years[0]?.value;
    const clientTheme = getClientTheme(user_client_id);

    const [state, setState] = useState({
        selectedVillageValue: +rowData.villageDetailsRowData.village_id,
        villageError: "",
        year: yearIndex,
        loading: false,
        submitMessage: "",
        villagesArray: rowData.villagesArray,
        soilData: soilTypes.reduce((acc, soil) => {
            const matchingData = filterMultipleVilagesData.find(item => item.soil_type_id === soil.value);

            acc[soil.value] = {
                ph: matchingData ? matchingData.ph : '',
                ec: matchingData ? matchingData.ec : '',
                soc: matchingData ? matchingData.oc : '',
                n: matchingData ? matchingData.n : '',
                p: matchingData ? matchingData.p : '',
                k: matchingData ? matchingData.k : '',
            };

            return acc;
        }, {}),
        fertilizerRecommendations: soilTypes.reduce((acc, soil) => {
            const matchingRecommendations = filterMultipleVilagesData.find(item => item.soil_type_id === soil.value);
            // const parseData = JSON.parse(matchingRecommendations?.recommendations)
            const parseData = typeof matchingRecommendations?.recommendations === "string" ? JSON.parse(matchingRecommendations.recommendations) : matchingRecommendations?.recommendations || [];


            acc[soil.value] = cropTypes.map(crop => ({
                cropType: crop.value,
                urea: parseData ? parseData.find((item) => item.cropType === crop.value)?.urea || '' : '',
                dap: parseData ? parseData.find((item) => item.cropType === crop.value)?.dap || '' : '',
                potash: parseData ? parseData.find((item) => item.cropType === crop.value)?.potash || '' : '',
                OrganicManure: parseData ? parseData.find((item) => item.cropType === crop.value)?.OrganicManure || '' : '',
            }));

            return acc;
        }, {}),
    });

    // const handleInputChange = (name, value) => {
    //     if (name === "selectedVillageValue") {
    //         setState((prevData) => ({
    //             ...prevData,
    //             selectedVillageValue: value,
    //             villageError: ""
    //         }));
    //     } else if (name === "year") {
    //         setState((prevData) => ({
    //             ...prevData,
    //             year: value,
    //         }));
    //     }
    // };

    // const handleAnalysisChange = (section, index, field, value) => {
    //     if (validateNumberInput(value)) {
    //         const soilType = soilTypes[index].value; // Get the soilType using index
    //         setState((prevData) => ({
    //             ...prevData,
    //             [section]: {
    //                 ...prevData[section],
    //                 [soilType]: {
    //                     ...prevData[section][soilType],
    //                     [field]: value,
    //                 },
    //             },
    //         }));
    //     }
    // };


    // const validateNumberInput = (value) => {
    //     const regex = /^\d{0,5}(\.\d{0,2})?$/;
    //     return regex.test(value);
    // };

    /* 🖨️ PRINT FUNCTION */
    const handlePrint = () => {

        if (!printRef.current) {
            alert("Print content not ready");
            return;
        }

        const win = window.open("", "_blank");

        if (!win) {
            alert("Popup blocked! Please allow popups.");
            return;
        }

        win.document.open();
        win.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
         @media print {
          body {
            zoom: 0.95;
          }
        }
          body {
            font-family: Roboto, Arial, sans-serif;
            margin: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: center;
            font-size: 13px;
          }
          thead {
            background: #e8f5e9;
          }
          button {
            display: none !important;
          }
        </style>
      </head>
      <body>
        ${printRef.current.innerHTML}
      </body>
    </html>
  `);

        win.document.close();

        win.onload = () => {
            win.focus();
            win.print();
            win.close();
        };
    };



    const soilAnalysisColumns = [
        { key: "ph", label: "pH" },
        { key: "ec", label: "EC" },
        { key: "soc", label: "SOC" },
        { key: "n", label: "N" },
        { key: "p", label: "P" },
        { key: "k", label: "K" },
    ];

    // const soilAnalysisData = soilTypes.map((soil) => ({
    //     soilType: soil.label,
    //     soilKey: soil.value,
    //     ...state.soilData[soil.value],
    // }));

    const fertilizerColumns = [
        { key: "cropType", label: "Crop Type" },
        { key: "urea", label: "Urea (N)" },
        { key: "dap", label: "DAP (P)" },
        { key: "potash", label: "Potash (K)" },
        { key: "OrganicManure", label: "Organic Manure" },
    ];


    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="md"
            keepMounted
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    backgroundColor: '#fdfdfd',
                    boxShadow: 6,
                    mt: 4,
                    alignSelf: 'flex-start',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: " #FFFFFF",
                    background: "linear-gradient(90deg, #1B5E20, #4CAF50)",
                    boxShadow: "0px 3px 10px rgba(0,0,0,0.3)",
                    color: '#fff',
                    px: 3,
                    py: 1,
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0, fontSize: '1.2rem', textTransform: "uppercase", fontWeight: "bold" }}>Village Details</DialogTitle>

                <IconButton onClick={() => handleClose()} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </Box>


            <DialogContent dividers>

                {/* <Grid container spacing={1} className="no-print">
                    {
                        [
                            { id: 1, name: "selectedVillageValue", label: "Village", value: +state.selectedVillageValue, options: state.villagesArray.filter((item) => +item.value === +state.selectedVillageValue), diabled: true },
                            { id: 2, name: "year", label: "Target Year", value: state.year, options: years, diabled: true },
                            { id: 3, label: "Print", }
                        ].map((field, index) => (
                            <Grid item size={{ xs: 12, md: field.id === 3 ? 3 : 4.5 }}>
                                {
                                    field.id === 3 ? (
                                        <CustomButton
                                            key={field.id}
                                            icon={<PrintIcon />}
                                            status={false}
                                            onClick={handlePrint}
                                            label={field.label}
                                            loadingLabel="Submitting.."
                                        />
                                    ) : (
                                        <SingleSelect
                                            name={field.name}
                                            label={field.label}
                                            options={field.options}
                                            value={field.value}
                                            onChange={handleInputChange}
                                        // disabled={field.diabled}
                                        />
                                    )
                                }
                            </Grid>
                        ))
                    }
                </Grid> */}

                <Box ref={printRef}>

                    <Grid container spacing={1}>
                        {[
                            {
                                id: 1, label: "Village", value: state.villagesArray.find(
                                    (v) => +v.value === +state.selectedVillageValue
                                )?.label
                            },
                            { id: 2, label: "Target Year", value: years.find((y) => y.value === state.year)?.label },
                            { id: 3, label: "Print", }
                        ].map((item) => (
                            <Grid item size={{ xs: 12, md: 4 }}>
                                {
                                    item.id === 3 ? (
                                        <CustomButton
                                            key={item.id}
                                            icon={<PrintIcon />}
                                            status={false}
                                            onClick={handlePrint}
                                            label={item.label}
                                            loadingLabel="Submitting.."
                                        />
                                    ) : (
                                        <Typography variant="body1">
                                            <strong>{item.label}:</strong>{" "}
                                            {item.value}
                                        </Typography>
                                    )
                                }
                            </Grid>
                        ))}
                    </Grid>


                    <Card sx={{ mt: 3 }}>
                        <CardContent>
                            <Typography variant="h6">Soil Analysis</Typography>

                            <TableContainer component={Paper}
                                sx={{
                                    width: "100%",
                                    maxHeight: "60vh",
                                    overflowX: "auto",        // ✅ horizontal scroll (mobile)
                                    overflowY: "auto",        // ✅ vertical scroll
                                    WebkitOverflowScrolling: "touch",
                                }}
                            >
                                <Table size="small"
                                    sx={{
                                        minWidth: 1000,
                                    }}>
                                    <TableHead sx={{
                                         backgroundColor: clientTheme.activeBg,
                                    }}>
                                        <TableRow>
                                            <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>Soil Type</TableCell>
                                            {soilAnalysisColumns.map((c) => (
                                                <TableCell key={c.key} align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>{c.label}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {soilTypes.map((soil) => (
                                            <TableRow key={soil.value}>
                                                <TableCell>{soil.label}</TableCell>
                                                {soilAnalysisColumns.map((c) => (
                                                    <TableCell key={c.key}>
                                                        <PrintCell value={state.soilData[soil.value][c.key]} />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>

                    <Card sx={{ mt: 3 }}>
                        <CardContent>
                            <Typography variant="h6">Fertilizer Recommendations</Typography>

                            {soilTypes.map((soil) => (
                                <Box key={soil.value} sx={{ mt: 2 }}>
                                    <Typography sx={{ color: "#EA90A7" }}>
                                        {soil.label}
                                    </Typography>

                                    <TableContainer component={Paper}
                                        sx={{
                                            width: "100%",
                                            maxHeight: "60vh",
                                            overflowX: "auto",        // ✅ horizontal scroll (mobile)
                                            overflowY: "auto",        // ✅ vertical scroll
                                            WebkitOverflowScrolling: "touch",
                                        }}
                                    >
                                        <Table size="small"
                                            sx={{
                                                minWidth: 1000,
                                            }}>
                                            <TableHead sx={{
                                                 backgroundColor: clientTheme.activeBg,
                                            }}>
                                                <TableRow>
                                                    {fertilizerColumns.map((c) => (
                                                        <TableCell key={c.key} align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>{c.label}</TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {state.fertilizerRecommendations[soil.value].map(
                                                    (row, i) => (
                                                        <TableRow key={i}>
                                                            {fertilizerColumns.map((c) => (
                                                                <TableCell key={c.key}>
                                                                    <PrintCell
                                                                        value={
                                                                            c.key === "cropType"
                                                                                ? cropTypes.find(
                                                                                    (x) => x.value === row.cropType
                                                                                )?.label
                                                                                : row[c.key]
                                                                        }
                                                                    />
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    )
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            ))}
                        </CardContent>
                    </Card>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SoilVillageDetailsModal;

